/**
 * 商品詳細ページ
 */
class ProductController{
    /**
     * Creates an instance of ProductController.
     *
     * @constructor
     */
    constructor() {
        this.cc = new CartChecker();
    }
    /* getter */
    get isProductPage(){
        return window._customer && window._customer.templatename && window._customer.templatename === 'product';
    }
    /**
     * 初期化
     */
    init(){
        this.param = {
            isCheckingCart : false
        };
        this.elements = {
            selectors : {
                html                   : '',
                body                   : '',
                product                : '.product',
                emailMeButtonAll       : '.email-me-button',/* CW Back in stock */
                emailMeBuyerNameAll    : '.email-frame-body .buyer-name',/* CW Back in stock */
                quantityInputAll       : '[is="quantity-input"][data-id]',
                quantityInputWithCCAll : '[is="quantity-input"][data-cartcount]',
                anyGiftUI              : '[data-anygift="ProductPageGiftUi"]',
                disabledByAnyGiftAll   : '[name="properties[_用途]"],[name="properties[のし紙]"],[name="properties[のしシール]"],[name="properties[ギフトシール]"],[name="properties[名入れ]"],[name="properties[_名入れ]"],[name="properties[_のし詳細情報]"],[name="properties[_名入れ詳細情報]"],[name="properties[_noshi]"]',
                anyGiftAddButton       : '.anygift-e-gift-modal__one__add-cart-button .anygift-e-gift-modal__one__add-cart-button-area__button',
                anyGiftMessage         : '.anygift-e-gift-modal__one__container .anygift-form-message-input',
                anyGiftInput           : '.anygift-e-gift-modal__one__container .anygift-form-from-input',
                reviews                : '#stamped-main-widget',
                reviewsAuthor          : '#stamped-main-widget [name="author"]',
                reviewsEmail           : '#stamped-main-widget [name="email"]',
                reviewsInputAll        : '#stamped-main-widget input'
            }
        };
        Utils.initDataElements(this);
        this.initQuantitySelector();
        Utils.updateQuantity(this.elements.quantityInputAll,this.isProductPage);
        this.initWindowEvent();
        this.initBackinStock();
        this.initAnyGiftButton();
        this.initReviewEmail();
        this.initReviewEnter();
        this.initAddToCartBindEvent();
    }
    /**
     * 購入数制限
     */
    initQuantitySelector(){
        let prevButton,nextButton;
        this.elements.quantityInputAll.forEach((quantityInput,i)=>{
            quantityInput.addEventListener('input',(e)=>{
                Utils.updateQuantity(this.elements.quantityInputAll);
            });
            prevButton = quantityInput.previousElementSibling;
            nextButton = quantityInput.nextElementSibling;
            if(prevButton && prevButton.classList.contains('quantity-selector__button')){
                prevButton.addEventListener('click',(e)=>{
                    Utils.updateQuantity(this.elements.quantityInputAll);
                });
            }
            if(nextButton && nextButton.classList.contains('quantity-selector__button')){
                nextButton.addEventListener('click',(e)=>{
                    Utils.updateQuantity(this.elements.quantityInputAll,true);
                });
                if(this.isProductPage){
                    nextButton.addEventListener('pointerup',(e)=>{
                        let elm = e.target;
                        if(!Utils.tagNameIs(e.target,'button')){
                            elm = e.target.closest('button');
                        }
                        if(elm && Utils.tagNameIs(elm,'button') && elm.disabled){
                            Utils.updateQuantity(this.elements.quantityInputAll);
                        }
                    });
                }
            }
        });
    }
    /**
     * windowイベント
     */
    initWindowEvent(){
        /* 別タブでカートへ商品を追加すること考慮しwindow focus時にカート内データを取得して必要ならリロードする */
        window.addEventListener('focus',(e)=>{
            if(this.param.isCheckingCart){
                return;
            }
            this.param.isCheckingCart = true;
            this.cc.updateCartCountByQuantityInputAll(this.elements.quantityInputWithCCAll,window._cart_base_info)
                .then((isChanged)=>{
                    this.param.isCheckingCart = false;
                    if(isChanged){
                        window.location.reload();
                    }
                })
                .catch((error)=>{
                    this.param.isCheckingCart = false;
                    console.log('Error : updateCartCountByQuantityInputAll');
                });
        });
    }
    /**
     * 再入荷通知登録ボタン
     */
    initBackinStock(){
        if(!window._customer || !window._customer.login){
            return;
        }
        document.addEventListener('click',(e)=>{
            const isExists = this.updateDataElementsAndGetExists('emailMeButtonAll',e.target);
            if(!isExists){
                return;
            }
            /* 名前欄がfirst_name last_nameになっているのをlast_name first_nameにする */
            Utils.updateDataElements(this,'emailMeBuyerNameAll');
            this.elements.emailMeBuyerNameAll.forEach((elm,i)=>{
                elm.value = window._customer.lastName + ' ' + window._customer.firstName;
            });
        });
    }
    /**
     * updateDataElements後elmが含まれるか返す
     *
     * @param {String} key
     * @param {HTMLElement} elm
     * @returns {boolean}
     */
    updateDataElementsAndGetExists(key,elm){
        Utils.updateDataElements(this,key);
        if(/^.+All$/.test(key)){
            let i;
            for(i=0;i<this.elements[key].length;i++){
                if(this.elements[key][i] === elm){
                    return true;
                }
            }
            return false;
        }else{
            return this.elements[key] === elm;
        }
    }
    /**
     * AnyGiftのモーダル初期化
     */
    initAnyGiftButton(){
        document.addEventListener('click',(e)=>{
            const classStr = e.target.getAttribute('class');
            /* モーダルオープンでのしform無効化 */
            if(classStr && -1 < classStr.indexOf('anygift-e-gift-modal__open-button')){
                this.initAnyGiftAddButton();
            }
        });
    }
    /**
     * タグ「eギフト」を含んでいない場合「住所を知らない相手にeギフトで贈る」ボタンを削除
     */
    initAnyGiftUI(){
        /* eギフト対応なら処理中止 */
        if(!window._product_info || (window._product_info && window._product_info.valid_egift)){
            return;
        }
        Utils.updateDataElements(this,'anyGiftUI');
        if(!this.elements.anyGiftUI){
            setTimeout(()=>{
                this.initAnyGiftUI();
            },200);
            return;
        }
        this.elements.anyGiftUI.remove();
    }
    /**
     * AnyGiftのモーダルカートに追加ボタン
     */
    initAnyGiftAddButton(){
        Utils.updateDataElements(this,'anyGiftAddButton');
        Utils.updateDataElements(this,'anyGiftMessage');
        Utils.updateDataElements(this,'anyGiftInput');
        if(!this.elements.anyGiftAddButton || !this.elements.anyGiftMessage || !this.elements.anyGiftInput){
            setTimeout(()=>{
                this.initAnyGiftAddButton();
            },200);
            return;
        }
        this.elements.anyGiftAddButton.addEventListener('click',(e)=>{
            if(this.elements.anyGiftMessage.value != '' && this.elements.anyGiftInput.value != ''){
                this.elements.disabledByAnyGiftAll.forEach((elm,i)=>{
                    elm.disabled = true;
                });
            }
        });
    }
    /**
     * レビューのメールアドレス入力欄にメールアドレス自動入力＆readonly属性付与
     */
    initReviewEmail(){
        /* ログインしてない場合処理中止 */
        if(!window._customer || (window._customer && !window._customer.login) || (window._customer && !window._customer.email) ){
            return;
        }
        /* レビューブロックが無い場合処理中止 */
        if(!this.elements.reviews){
            return;
        }
        /* reviewsAuthorが表示されるまで再起処理 */
        Utils.updateDataElements(this,'reviewsAuthor');
        if(!this.elements.reviewsAuthor){
            setTimeout(()=>{
                this.initReviewEmail();
            },200);
            return;
        }
        Utils.updateDataElements(this,'reviewsEmail');
        /* メールアドレス入力欄が無い場合処理中止 */
        if(!this.elements.reviewsEmail){
            return;
        }
        /* メールアドレス自動入力 */
        this.elements.reviewsEmail.value = window._customer.email;
        /* readonly属性付与 */
        this.elements.reviewsEmail.readOnly = true;
    }
    /**
     * レビューフォームのEnterキーによるsubmitを無効化
     */
    initReviewEnter(){
        Utils.updateDataElements(this,'reviewsInputAll');
        if(!this.elements.reviewsInputAll.length){
            setTimeout(()=>{
                this.initReviewEnter();
            },200);
            return;
        }
        this.initReviewKeydown();    
    }
    /**
     * レビューフォームのinputのkeydownイベント登録
     */
    initReviewKeydown(){
        Utils.updateDataElements(this,'reviewsInputAll');
        if(!this.elements.reviewsInputAll.length){
            return;
        }
        this.elements.reviewsInputAll.forEach((input,i)=>{
            /* Enterキーによるsubmitを無効化 */
            input.addEventListener('keydown',(e)=>{
                if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
                    Utils.cancelEvent(e);
                }
            });
        });
    }

    /**
     * カートに入れるボタンのクリックイベントをバインド
     */
    initAddToCartBindEvent() {
        // 店舗受取商品かどうか判定
        const url = window.location.href;
        const validPaths = ['kurumicco5_instore_honten', 'kurumicco8_instore_honten', 'kurumicco16_instore_honten', 'kurumicco5_instore_puc', 'kurumicco8_instore_puc', 'kurumicco16_instore_puc'];
        const isValidProductPath = validPaths.some(path => url.includes(path));
        if (isValidProductPath === false) {
            console.log("[DEBUG] 店舗受取商品ではありません。");
            return;
        }

        // カートに入れるボタン取得
        const addToCartButton = document.querySelector('buy-buttons button');
        if (!addToCartButton) {
            console.log("[DEBUG] カートに入れるボタンありません。");
            return;
        }

        // form取得
        const thisForm = addToCartButton.closest('form');

        // クリックイベントを登録する
        addToCartButton.addEventListener('click', function(event) {
            event.preventDefault(); // 必要に応じてデフォルトの送信動作を無効化

            // 現在の日時を取得
            const now = new Date();

            // 現在の曜日、時間、分を取得
            const currentDay = now.getDay(); // 0 (日) から 6 (土) の数字
            const currentHour = now.getHours(); // 0 (午前0時) から 23 (午後11時)
            const currentMinute = now.getMinutes(); // 0 から 59

            console.log(`[DEBUG] 現在の日時: ${now}`);
            console.log(`[DEBUG] 曜日: ${currentDay}`);
            console.log(`[DEBUG] 現在の時刻: ${currentHour}時${currentMinute}分`);

            // 条件: 木曜日(4) かつ 午前9:00〜午前9:30
            if (currentDay === 4 && 
                currentHour === 9 && 
                currentMinute >= 0 && currentMinute <= 30) {
                alert("システムメンテンナンスに伴い下記の期間ご注文できません。\n※毎週火曜日と木曜日の午前9時から9時30分の間");
            } else {
                thisForm.submit();
            }
        });
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const pc = new ProductController();
    pc.init();
});